import axios from "axios";
import { HOST } from "config/config";

export function getQuickbooksCustomer(userGroupId) {
  return (dispatch) => {
    return dispatch({
      type: "GET_QUICKBOOKS_CUSTOMERS_PENDING",
      payload: axios
        .get(`${HOST}/api/quickbooks/customers?userGroupId=${userGroupId}`)
        .then((response) => response.data)
        .then((json) =>
          dispatch({
            type: "GET_QUICKBOOKS_CUSTOMERS_FULFILLED",
            payload: json,
          })
        ),
    });
  };
}
